<template>
  <div class="popup-back">
    <section class="popup movie-tutorial-popup">
      <h1 class="popup-title" tabindex="1">전체 카테고리 팝업</h1>
      <div class="popup-button-close">
        <button type="button" @click.prevent="closeFn()" href="#">
          <img src="../../assets/images/common/btn-popup-close.svg" alt="팝업 닫기">
        </button>
      </div>
      <div class="movie-tutorial-wrap">
        <p class="movie-tutorial-hd">
          <span>이제 영화 메뉴 내의</span>
          <span>모든 영화를 마음껏 즐기세요.</span>
        </p>
        <p class="movie-tip">
          <span>별도 이용권으로 제공되었던 <strong>PLAYY 영화가</strong></span>
          <span><strong>Wavvie 영화와 통합되어</strong> Wavve 이용권&ast;으로</span>
          <span>볼 수 있는 영화가 더욱 풍성해졌어요.</span>
        </p>
        <img src="../../assets/images/movie/img-movietag.png" class="movie-tutorial-img" alt="영화 신세계, 시빌 워, 오블리비언 포스터 이미지">
      </div>
      <div class="movie-tutorial-exclamation">
        <ul>
          <li>Wavve 이용권&ast; : Basic, Standard, Premium 및 그에 준하는 구 이용권</li>
          <li>별도로 운영되는 ‘영화 플러스’는 개별 구매 후 시청 가능합니다. ‘영화 플러스’는 영화 메뉴에서 제공되는 배너를 통해 이용할 수 있습니다.</li>
        </ul>
      </div>
      <div class="popup-button-close">
        <a @click.prevent="closeFn()" href="#">
          <img src="../../assets/images/common/btn-popup-close.svg" alt="팝업 닫기">
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import { setDisableScrolling } from '@/common/utils/common'

export default {
  name: 'WavviePopup',
  props: {
    closeFn: {
      type: Function
    }
  },
  created () {
    setDisableScrolling(true)
  }
}
</script>
